import ServiceLanding from "../components/services/ServiceLanding";

export default function ServiceDetail({ service }) {
  return <ServiceLanding service={service} />;
}
